import { render, staticRenderFns } from "./DetectionFilterUrlLayout.vue?vue&type=template&id=5bf872cf&scoped=true"
import script from "./DetectionFilterUrlLayout.vue?vue&type=script&lang=js"
export * from "./DetectionFilterUrlLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf872cf",
  null
  
)

export default component.exports